// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.chat-cancel__text[data-v-6ac5abe7] {\n  color: #3f43ad;\n  font-size: 14px;\n}\n", ""]);
// Exports
module.exports = exports;
